module.exports = __webpack_public_path__ + "img/88d372c.png";